import { get } from 'lodash/fp';
import axios from './axios';
import config from '../../helpers/config';

export default (itemsToRename) => {
  axios.post(
    `${config.designBuilderLoadDesignPath}/${itemsToRename[0].designId}/items/rename`,
    itemsToRename,
  ).then(get('data'));
};
